import { createContext } from "react";
import { IDateRangePreset } from "../interfaces";

export interface DateRangeContextType {
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
  selectedPreset: IDateRangePreset | undefined;
  setDateRange: (startDate: Date, endDate: Date) => void;
  setSelectedPreset: (preset: IDateRangePreset | undefined) => void;
}

export const DateRangeContext = createContext<DateRangeContextType | undefined>(undefined);
